"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(resolveRootMode),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(loadPrivatePartialConfig);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadPrivatePartialConfig;
exports.loadPartialConfig = void 0;

function _path() {
  var data = _interopRequireDefault(require("path"));

  _path = function _path() {
    return data;
  };

  return data;
}

function _gensync() {
  var data = _interopRequireDefault(require("gensync"));

  _gensync = function _gensync() {
    return data;
  };

  return data;
}

var _plugin = _interopRequireDefault(require("./plugin"));

var _util = require("./util");

var _item = require("./item");

var _configChain = require("./config-chain");

var _environment = require("./helpers/environment");

var _options = require("./validation/options");

var _files = require("./files");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function resolveRootMode(rootDir, rootMode) {
  var upwardRootDir, _upwardRootDir;

  return _regeneratorRuntime.wrap(function resolveRootMode$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = rootMode;
          _context.next = _context.t0 === "root" ? 3 : _context.t0 === "upward-optional" ? 4 : _context.t0 === "upward" ? 7 : 12;
          break;

        case 3:
          return _context.abrupt("return", rootDir);

        case 4:
          return _context.delegateYield((0, _files.findConfigUpwards)(rootDir), "t1", 5);

        case 5:
          upwardRootDir = _context.t1;
          return _context.abrupt("return", upwardRootDir === null ? rootDir : upwardRootDir);

        case 7:
          return _context.delegateYield((0, _files.findConfigUpwards)(rootDir), "t2", 8);

        case 8:
          _upwardRootDir = _context.t2;

          if (!(_upwardRootDir !== null)) {
            _context.next = 11;
            break;
          }

          return _context.abrupt("return", _upwardRootDir);

        case 11:
          throw Object.assign(new Error("Babel was run with rootMode:\"upward\" but a root could not " + "be found when searching upward from \"".concat(rootDir, "\".\n") + "One of the following config files must be in the directory tree: " + "\"".concat(_files.ROOT_CONFIG_FILENAMES.join(", "), "\".")), {
            code: "BABEL_ROOT_NOT_FOUND",
            dirname: rootDir
          });

        case 12:
          throw new Error("Assertion failure - unknown rootMode value.");

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function loadPrivatePartialConfig(inputOpts) {
  var args, _args$envName, envName, _args$cwd, cwd, _args$root, rootDir, _args$rootMode, rootMode, caller, absoluteCwd, absoluteRootDir, context, configChain, options;

  return _regeneratorRuntime.wrap(function loadPrivatePartialConfig$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!(inputOpts != null && (typeof inputOpts !== "object" || Array.isArray(inputOpts)))) {
            _context2.next = 2;
            break;
          }

          throw new Error("Babel options must be an object, null, or undefined");

        case 2:
          args = inputOpts ? (0, _options.validate)("arguments", inputOpts) : {};
          _args$envName = args.envName, envName = _args$envName === void 0 ? (0, _environment.getEnv)() : _args$envName, _args$cwd = args.cwd, cwd = _args$cwd === void 0 ? "." : _args$cwd, _args$root = args.root, rootDir = _args$root === void 0 ? "." : _args$root, _args$rootMode = args.rootMode, rootMode = _args$rootMode === void 0 ? "root" : _args$rootMode, caller = args.caller;
          absoluteCwd = _path().default.resolve(cwd);
          return _context2.delegateYield(resolveRootMode(_path().default.resolve(absoluteCwd, rootDir), rootMode), "t0", 6);

        case 6:
          absoluteRootDir = _context2.t0;
          context = {
            filename: typeof args.filename === "string" ? _path().default.resolve(cwd, args.filename) : undefined,
            cwd: absoluteCwd,
            root: absoluteRootDir,
            envName: envName,
            caller: caller
          };
          return _context2.delegateYield((0, _configChain.buildRootChain)(args, context), "t1", 9);

        case 9:
          configChain = _context2.t1;

          if (configChain) {
            _context2.next = 12;
            break;
          }

          return _context2.abrupt("return", null);

        case 12:
          options = {};
          configChain.options.forEach(function (opts) {
            (0, _util.mergeOptions)(options, opts);
          });
          options.babelrc = false;
          options.configFile = false;
          options.passPerPreset = false;
          options.envName = context.envName;
          options.cwd = context.cwd;
          options.root = context.root;
          options.filename = typeof context.filename === "string" ? context.filename : undefined;
          options.plugins = configChain.plugins.map(function (descriptor) {
            return (0, _item.createItemFromDescriptor)(descriptor);
          });
          options.presets = configChain.presets.map(function (descriptor) {
            return (0, _item.createItemFromDescriptor)(descriptor);
          });
          return _context2.abrupt("return", {
            options: options,
            context: context,
            ignore: configChain.ignore,
            babelrc: configChain.babelrc,
            config: configChain.config
          });

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var loadPartialConfig = (0, _gensync().default)( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inputOpts) {
  var result, options, babelrc, ignore, config;
  return _regeneratorRuntime.wrap(function _callee$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield(loadPrivatePartialConfig(inputOpts), "t0", 1);

        case 1:
          result = _context3.t0;

          if (result) {
            _context3.next = 4;
            break;
          }

          return _context3.abrupt("return", null);

        case 4:
          options = result.options, babelrc = result.babelrc, ignore = result.ignore, config = result.config;
          (options.plugins || []).forEach(function (item) {
            if (item.value instanceof _plugin.default) {
              throw new Error("Passing cached plugin instances is not supported in " + "babel.loadPartialConfig()");
            }
          });
          return _context3.abrupt("return", new PartialConfig(options, babelrc ? babelrc.filepath : undefined, ignore ? ignore.filepath : undefined, config ? config.filepath : undefined));

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee);
}));
exports.loadPartialConfig = loadPartialConfig;

var PartialConfig = /*#__PURE__*/function () {
  function PartialConfig(options, babelrc, ignore, config) {
    _classCallCheck(this, PartialConfig);

    this.options = options;
    this.babelignore = ignore;
    this.babelrc = babelrc;
    this.config = config;
    Object.freeze(this);
  }

  _createClass(PartialConfig, [{
    key: "hasFilesystemConfig",
    value: function hasFilesystemConfig() {
      return this.babelrc !== undefined || this.config !== undefined;
    }
  }]);

  return PartialConfig;
}();

Object.freeze(PartialConfig.prototype);